import React from 'react';
import { Box, Select, MenuItem, FormControl } from '@material-ui/core';

function MonthSelector({ selectedMonths, handleChange }) {
  return (
    <Box sx={ { minWidth: 120 } }>
      <FormControl size='small'>
        <Select
          id='demo-simple-select'
          value={ selectedMonths }
          variant='outlined'
          onChange={ handleChange }
        >
          <MenuItem value={ 1 }>1 Month</MenuItem>
          <MenuItem value={ 2 }>2 Months</MenuItem>
          <MenuItem value={ 6 }>6 Months</MenuItem>
          <MenuItem value={ 12 }>12 Months</MenuItem>
          <MenuItem value='All'>All</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
}

export default MonthSelector;
